module.exports = __webpack_public_path__ + "static/media/off_complete.b0fc1b91.svg";